import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { FaqsComponent } from './faqs/faqs.component';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotResetPassComponent } from './forgot-reset-pass/forgot-reset-pass.component';
import { AchievementComponent } from './features/about/achievement/achievement.component';
import { AnnualReportsComponent } from './features/about/annual-reports/annual-reports.component';
import { CircularComponent } from './features/about/circular/circular.component';
import { ImportantlinksComponent } from './features/about/importantlinks/importantlinks.component';
import { OrganizationChartComponent } from './features/about/organization-chart/organization-chart.component';
import { TenderComponent } from './features/about/tender/tender.component';


import { AuthGuardService } from './service/AuthGuardService';

import { RwaRegPublishFormComponent } from './RWAModule/Rwa Registration/rwa-reg-publish-form/rwa-reg-publish-form.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { OtpLoginComponent } from './otp-login/otp-login.component';
import { DeptLoginComponent } from './dept-login/dept-login.component';
import { GlobalpaymentresponseComponent } from './globalpaymentresponse/globalpaymentresponse.component';
import { OnlineBookingComponent } from './online-booking/online-booking.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { TermandconditionComponent } from './copyright/termandcondition/termandcondition.component';
import { PrivacyComponent } from './copyright/privacy/privacy.component';
import { DisclamerComponent } from './copyright/disclamer/disclamer.component';
import { HyperlinkComponent } from './copyright/hyperlink/hyperlink.component';
import { WebinfoComponent } from './copyright/webinfo/webinfo.component';
import { HelpComponent } from './copyright/help/help.component';
import { AboutUsComponent } from './copyright/about-us/about-us.component';
import { ContactUsComponent } from './copyright/contact-us/contact-us.component';
import { ContentArchivalComponent } from './copyright/content-archival/content-archival.component';
import { ContentReviewComponent } from './copyright/content-review/content-review.component';
import { CampComponent } from './copyright/camp/camp.component';
import { CamwebsiteMonitoringComponent } from './copyright/camwebsite-monitoring/camwebsite-monitoring.component';
import { SecurityComponent } from './copyright/security/security.component';
import { ContingencyComponent } from './copyright/contingency/contingency.component';
import { SitemapComponent } from './copyright/sitemap/sitemap.component';
import { FeedbackComponent } from './copyright/feedback/feedback.component';
import { PublicHearingManualComponent } from './copyright/public-hearing-manual/public-hearing-manual.component';
import { PhFeedbackComponent } from './copyright/ph-feedback/ph-feedback.component';
import { LrDashboardComponent } from './copyright/lr-dashboard/lr-dashboard.component';
const routes: Routes = [




  { path: 'login', component: LoginComponent, },
  { path: 'otp', component: OtpLoginComponent, },
  { path: 'signIn', component: RegistrationComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'forgotPassword', component: ForgotPasswordComponent },
  { path: 'resetPass', component: ForgotResetPassComponent },
  { path: 'achivement', component: AchievementComponent },
  { path: 'anualReport', component: AnnualReportsComponent },
  { path: 'circular', component: CircularComponent },
  { path: 'implinks', component: ImportantlinksComponent },
  { path: 'orgchart', component: OrganizationChartComponent },
  { path: 'tender', component: TenderComponent },
  { path: 'rwaRegPublishForm', component: RwaRegPublishFormComponent },
  { path: 'faqs', component: FaqsComponent },
  { path: 'deptlogin', component: DeptLoginComponent },
  { path: 'globalpaymentresponse', component: GlobalpaymentresponseComponent },
  { path: 'onlinebooking', component: OnlineBookingComponent },



  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'meetingSchedule',
    loadChildren: () =>
      import('./MeetingSchedule/meeting-schedule.module').then(m => m.MeetingScheduleModule)
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'feature-list',
    loadChildren: () =>
      import('./features/feature-list/feature-list.module').then(
        m => m.FeatureListModule
      )
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'examples',
    loadChildren: () =>
      import('./features/examples/examples.module').then(m => m.ExamplesModule)
  },
  {
    path: 'housing',
    loadChildren: () =>
      import('./HousingModule/housing-serrvice-module.module').then(m => m.HousingSerrviceModuleModule)
  },

  {
    path: 'landChange',
    loadChildren: () =>
      import('./Land Change Suggestion/land-change-suggestion-module.module').then(m => m.LandChangeSuggestionModuleModule)
  },

  {
    path: 'permission-lift',
    loadChildren: () =>
      import('./PermissionLiftModule/permission-lif.module').then(m => m.PermissionLifModule)
  },

  {
    path: 'communityHall',
    loadChildren: () =>
      import('./Community Hall/community-hall-service.module').then(m => m.CommunityHallServiceModule)
  },

  {
    path: 'personalHearing',
    loadChildren: () =>
      import('./PersonalHearingModule/personal-hearing.module').then(m => m.PersonalHearingModule)
  },

  {
    path: 'meetingSchedule',
    loadChildren: () =>
      import('./MeetingSchedule/meeting-schedule.module').then(m => m.MeetingScheduleModule)
  },

  {
    path: 'rwa',
    loadChildren: () =>
      import('./RWAModule/rwa-services.module').then(m => m.RwaServicesModule)
  },

  {
    path: 'bookfillsystem',
    loadChildren: () =>
      import('./Booking_Filling_System/booking-filling-system.module').then(m => m.BookingFillingSystemModule)
  },

  {
    path: 'admin',
    loadChildren: () =>
      import('./AdminModule/admin-service.module').then(m => m.AdminServiceModule)
  },
  {
    path: 'subadmin',
    loadChildren: () =>
      import('./SubAdminModule/sub-admin.module').then(m => m.SubAdminModule)
  },

  {
    path: 'alterationFlats',
    loadChildren: () =>
      import('./addition-alteration-module/addition-alteration-module.module').then(m => m.AdditionAlterationModuleModule)
  },
  {
    path: 'motrgage',
    loadChildren: () =>
      import('./Mortgage of Flat or Plot/motrgageofFlat.module').then(m => m.MortgageOfFlatModule)
  },
  {
    path: 'parkBooking',
    loadChildren: () =>
      import('./Park Booking/park-booking.module').then(m => m.ParkBookingModule)
  },
  {
    path: 'waterbill',
    loadChildren: () =>
      import('./water-bill-module/water-bill-module.module').then(m => m.WaterBillModuleModule)
  },
  {
    path: 'eot',
    loadChildren: () =>
      import('./eot-flat-ploat/eot-flat-ploat.module').then(m => m.EotFlatPloatModule)
  },
  {
    path: 'landConversions',
    loadChildren: () =>
      import('./land-conversion-new/land-conversion-new.module').then(m => m.LandConversionNewModule)
  },
  {
    path: 'lease-restoration',
    loadChildren: () =>
      import('./Lease-Restoration/lease-restoration.module').then(m => m.LeaseRestorationModule)
  },
  {
    path: 'lease-lisense',
    loadChildren: () =>
      import('./Lease & License Fee/leaseAndLisense.module').then(m => m.LeaseAndLisenseModule)
  },

  {
    path: 'fuelStation',
    loadChildren: () =>
      import('./fuel-station/fuel-station.module').then(m => m.FuelStationModule)
  },
  {
    path: 'change-premises',
    loadChildren: () =>
      import('./change-of-premises/change-of-premises.module').then(m => m.ChangeOfPremisesModule)
  },
  {
    path: 'contractRequirtment',
    loadChildren: () =>
      import('./contract-recruitement/contract-recruitement.module').then(m => m.ContractRecruitementModule)
  },
  {
    path: 'directRequirtment',
    loadChildren: () =>
      import('./direct-recruitement/direct-recruitement.module').then(m => m.DirectRecruitementModule)
  },
  {
    path: 'deputationRequirtment',
    loadChildren: () =>
      import('./deputation-recruitment/deputation-recruitment.module').then(m => m.DeputationRecruitmentModule)
  },
  {
    path: 'lostofproperty',
    loadChildren: () =>
      import('./lost-copy-propert/lost-copy-propert.module').then(m => m.LostCopyPropertModule)
  },
  {
    path: 'adoptionofpark',
    loadChildren: () =>
      import('./adoption-of-park/adoption-of-park.module').then(m => m.AdoptionOfParkModule)
  },

  { path: 'copyrigth', component: CopyrightComponent },
  { path: 'termcondition', component: TermandconditionComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'disclamer', component: DisclamerComponent },
  { path: 'hyperlink', component: HyperlinkComponent },
  { path: 'webinfo', component: WebinfoComponent },
  { path: 'help', component: HelpComponent },
  { path: 'aboutus', component: AboutUsComponent },
  { path: 'contactus', component: ContactUsComponent },
  { path: 'contentarchival', component: ContentArchivalComponent },
  { path: 'contentreview', component: ContentReviewComponent },
  { path: 'camp', component: CampComponent },
  { path: 'website-monitor', component: CamwebsiteMonitoringComponent },
  { path: 'security', component: SecurityComponent },
  { path: 'contingency', component: ContingencyComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'phmanual', component: PublicHearingManualComponent },
  { path: 'ph-feedback', component: PhFeedbackComponent },
  { path: 'reports', component: LrDashboardComponent },












  { path: '**', redirectTo: '/404' }

]

@NgModule({
  // useHash supports github.io demo page, remove in your app
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
